import { INSTANCE, INSTANCELIST } from './API'

export const applyGiftCardSplitFilter = (filter = {}) => {
    const next = { ...filter }
    const splitKind = next.splitKind
    delete next.splitKind

    if (splitKind === 'original') {
        next.status = 'split'
    } else if (splitKind === 'child') {
        next.parent = { $ne: null }
    } else if (splitKind === 'none') {
        next.parent = null
        if (!next.status) {
            next.status = { $ne: 'split' }
        }
    }

    return next
}

export const getGiftCards = ({ queryKey }) =>
    new Promise((resolve, reject) => {
        const { sort, range, filter, token, tabFilter } = queryKey[1]

        INSTANCELIST({
            method: 'get',
            url: '/gift-cards/details',
            headers: {
                Authorization: `Bearer ${token}`,
            },
            params: {
                sort: JSON.stringify(sort),
                range: JSON.stringify(range),
                filter: JSON.stringify(applyGiftCardSplitFilter(filter)),
                ...tabFilter,
            },
        })
            .then(resolve)
            .catch(reject)
    })

export const getCustomerGiftCards = ({ queryKey }) =>
    new Promise((resolve, reject) => {
        const { userId, sort, range, filter, token } = queryKey[1]

        INSTANCELIST({
            method: 'get',
            url: `/gift-cards/details?customer=${userId}`,
            headers: {
                Authorization: `Bearer ${token}`,
            },
            params: {
                sort: JSON.stringify(sort),
                range: JSON.stringify(range),
                filter: JSON.stringify(filter),
            },
        })
            .then(resolve)
            .catch(reject)
    })

export const CreateGiftCard = (form, token) =>
    new Promise((resolve, reject) => {
        INSTANCE({
            method: 'post',
            url: '/gift-cards',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            data: JSON.stringify(form),
        })
            .then(resolve)
            .catch(reject)
    })

export const getSingleGiftCard = ({ queryKey }) =>
    new Promise((resolve, reject) => {
        const { giftCardId, token } = queryKey[1]

        INSTANCE({
            method: 'get',
            url: `/gift-cards/${giftCardId}/details`,
            headers: {
                Authorization: `Bearer ${token}`,
            },
        })
            .then(resolve)
            .catch(reject)
    })

export const EditGiftCard = (form, token, giftCardId) =>
    new Promise((resolve, reject) => {
        INSTANCE({
            method: 'put',
            url: `/gift-cards/${giftCardId}`,
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            data: JSON.stringify(form),
        })
            .then(resolve)
            .catch(reject)
    })

export const findUnlinkedGiftCardsByPhones = (phones, token) =>
    new Promise((resolve, reject) => {
        INSTANCE({
            method: 'post',
            url: '/gift-cards/unlinked-by-phones',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            data: JSON.stringify({ phones }),
        })
            .then((response) => resolve(response?.list || []))
            .catch(reject)
    })

export const linkGiftCardsToCustomer = (customerId, giftCardIds, token) =>
    new Promise((resolve, reject) => {
        INSTANCE({
            method: 'post',
            url: '/gift-cards/link-to-customer',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            data: JSON.stringify({ customerId, giftCardIds }),
        })
            .then((response) => resolve(response?.linked || []))
            .catch(reject)
    })

export const splitGiftCard = (giftCardId, amounts, token) =>
    new Promise((resolve, reject) => {
        INSTANCE({
            method: 'post',
            url: `/gift-cards/${giftCardId}/split`,
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            data: JSON.stringify({ amounts }),
        })
            .then(resolve)
            .catch(reject)
    })
